export const BLOG_API_ENDPOINT = 'https://knitandnote.com/graphql';
